import React, {useCallback, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import BlankCoverImage from '../assets/blank_cover.png'
import {CubeIcon, AnnotationIcon, TagIcon, CalendarIcon} from '@heroicons/react/outline'
import QuizModal from '../components/Content/QuizModal'
import LovesCard from '../components/Content/LovesCard'
import CommentsCard from '../components/Content/CommentsCard'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { authenticated } from '../recoil/auth'
import { contentDetail, contentLoading, contentMessage } from '../recoil/content'
import DocsList from '../components/Content/DocsList'
import { domainWeb } from '../config/constants'
import axios from 'axios';
import VideoLinkList from '../components/Content/VideoLinkList'
import QuizzesList from '../components/Content/QuizzesList'
import WaitingText from '../components/WaitingText'
import { quizDetail } from '../recoil/quiz'

const ContentDetailPage = () => {
    const { contentId } = useParams();
    const auth = useRecoilValue(authenticated);
    const [loading, setLoading] = useRecoilState(contentLoading);
    const [content, setContent] = useRecoilState(contentDetail);
    const setMessage = useSetRecoilState(contentMessage);
    const [showQuizModal, setShowQuizModal] = useState(false);
    const setQuizSelected = useSetRecoilState(quizDetail);

    const middleLink = {
        label: "Konten",
        route: "/contents"
    };

    const clickQuiz = (quiz) => {
        setQuizSelected(quiz);
        setShowQuizModal(true);
    }

    const closeQuiz = () => {
        setQuizSelected({});
        setShowQuizModal(false);
    }

    const getContentDetail = useCallback(async () => {
        setLoading(true);
        setMessage({});
        try {
            let url = `${domainWeb}/contents/${contentId}`;
            let response = await axios.get(url, 
                {headers: {
                    'Content-Type': 'application/json', 
                    'Accept': 'application/json', 
                    'Authorization': 'Bearer ' + auth.token
                }},
            );
            setContent(response.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }, [auth.token, setLoading, setMessage, contentId, setContent]);

    useEffect(() => {
        document.title = "Detail Konten - Admin Hi Nano";
        getContentDetail();
    }, [getContentDetail]);

    return (
        <div className="flex min-h-screen bg-slate-100">
            <Sidebar />
            <div className="flex-1 p-10 ml-28">
                <Header title="Detail Konten" middle={middleLink} />
                <div className="px-8 py-5 mb-6 bg-white rounded-lg shadow">
                    <h3 className="text-xl font-semibold">Detail Konten</h3>
                    <form action="">
                        <div className="flex gap-10 mt-5">
                            {/* COVER */}
                            <div className="flex flex-col items-center w-1/4 gap-5">
                                <img src={content.cover ? content.cover : BlankCoverImage} alt="Cover" className="w-full rounded-lg" />
                                {loading && <WaitingText /> }
                            </div>
                            <div className="flex flex-col flex-1 gap-8">
                                {/* TITLE */}
                                <div className="flex flex-col items-start">
                                    <label htmlFor="title" className="text-sm">Judul Konten</label>
                                    <div className="flex items-center w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                                        <CubeIcon className="w-6 h-6" />
                                        <p className="w-full">{content.title}</p>
                                    </div>
                                </div>
                                {/* DESC */}
                                <div className="flex flex-col items-start">
                                    <label htmlFor="description" className="text-sm">Deskripsi</label>
                                    <div className="flex items-start w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                                        <AnnotationIcon className="w-6 h-6" />
                                        <p className="w-full">{content.description}</p>
                                    </div>
                                </div>
                                {/* TOPIC */}
                                <div className="flex flex-col items-start">
                                    <label htmlFor="topic" className="text-sm">Topic</label>
                                    <div className="flex items-center w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
                                        <TagIcon className="w-6 h-6" />
                                        <p className="w-full">{content.topic}</p>
                                    </div>
                                </div>
                                
                                <DocsList />
                                <VideoLinkList/>
                                <QuizzesList clickQuiz={clickQuiz} />

                                {/* DATE */}
                                <div className="flex flex-col items-start">
                                    <label htmlFor="title" className="text-sm">Tanggal Pembuatan</label>
                                    <div className="flex items-center w-full gap-5 px-5 py-3 my-2 rounded-lg bg-slate-50">
                                        <CalendarIcon className="w-6 h-6" />
                                        <p className="w-full">{content.date}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="flex items-start gap-10">
                    <LovesCard content={contentId} />
                    <CommentsCard content={contentId} />
                </div>
            </div>
            {
                showQuizModal ? (
                    <QuizModal closeQuiz={closeQuiz} />
                ) : ("")
            }
            
        </div>
    )
}

export default ContentDetailPage